import axios from 'axios'

export interface setPaymentMethodAxiosRequest {
  cartId: string
  cc_stripejs_token: string
}
export const setPaymentMethodAxios = async (
  payload: setPaymentMethodAxiosRequest,
): Promise<any> => {
  const { cartId, cc_stripejs_token } = payload
  const responseData = await axios.post(
    'stripe/guest-set-payment-method-on-cart/' + cartId,
    {
      cc_stripejs_token,
    },
    {
      baseURL: `${process.env.NEXT_PUBLIC_URL}/rest/V1`,
      headers: {
        'Content-Type': 'application/json',
      },
    },
  )

  return responseData
}

export const placeHolderAxiosGuest = async (payload: {
  cartId: string
}): Promise<any> => {
  const { cartId } = payload
  const responseData = await axios
    .post('stripe/guest-place-orders/' + cartId, undefined, {
      baseURL: `${process.env.NEXT_PUBLIC_URL}/rest/V1`,
      headers: {
        'Content-Type': 'application/json',
      },
      validateStatus: function (status) {
        return status < 500 // Resolve only if the status code is less than 500
      },
    })
    .catch((err) => {
      return err
    })

  return responseData
}

export const setPaymentMethodAxiosCustomer = async (
  payload: setPaymentMethodAxiosRequest,
  token: string,
): Promise<any> => {
  const { cartId, cc_stripejs_token } = payload
  const responseData = await axios.post(
    'stripe/set-payment-method-on-cart',
    {
      cc_stripejs_token,
    },
    {
      baseURL: `${process.env.NEXT_PUBLIC_URL}/rest/V1`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `bearer ${token}`,
      },
    },
  )

  return responseData
}

export const placeHolderAxiosGuestCustomer = async (
  payload: { cartId: string },
  token: string,
): Promise<any> => {
  const { cartId } = payload
  const responseData = await axios
    .post('stripe/place-orders', null, {
      baseURL: `${process.env.NEXT_PUBLIC_URL}/rest/V1`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `bearer ${token}`,
      },
      validateStatus: function (status) {
        return status < 500 // Resolve only if the status code is less than 500
      },
    })
    .catch((err) => {
      return err
    })

  return responseData
}
